import {Route, Switch} from "react-router-dom";
import Root from "./layout/Root";
import Page from "./layout/Page";
import {LoadingCasinoLobby} from "./casino/LoadingCasinoLobby";
import React from "react";
import {ReactComponent as SportsLoader} from "./assets/ball_loader.svg";
import {ReactComponent as PokerLoader} from "./assets/poker_loader.svg";
import {ReactComponent as CasinoLoader} from "./assets/casino_loader.svg";

export const SuspenseLoaders = () => {
    return (
        <Route>
            <Switch>
                <Route path={"/casino"}>
                    <Root footer={false}>
                        <Page>
                            <div className={"casino-container"}>
                                <div className={"carousel-loader"}></div>
                                <LoadingCasinoLobby />
                            </div>
                        </Page>
                    </Root>
                </Route>
                <Route path={"/sportsbook"}>
                    <Root footer={false}>
                        <div>
                            <div className="preloader">
                                <SportsLoader />
                            </div>
                        </div>
                    </Root>
                </Route>
                <Route path={"/poker"}>
                    <Root footer={false}>
                        <div>
                            <div className="preloader">
                                <PokerLoader />
                            </div>
                        </div>
                    </Root>
                </Route>
                <Route>
                    <Root footer={false}>
                        <div></div>
                    </Root>
                </Route>
            </Switch>
        </Route>
    )
}